import { DataSource } from '@angular/cdk/table';
import { Component, OnInit, Input } from '@angular/core';
import { PageEvent } from '@angular/material';
import {
  MemberResponseInterface,
  PendingInvitationResponse,
  PendingInvitationResponseInterface
} from '@careapp/angular-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { RolePipe } from '../../shared/pipes/role.pipe';
import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';
import { InvitationResponseInterface } from '@careapp/angular-sdk';
import * as moment from 'moment-timezone';

@Component({
  selector: 'ca-staff-list',
  templateUrl: 'staff-list.component.html',
  styleUrls: ['./staff-list.component.scss']
})
export class StaffListComponent implements OnInit {
  public tableConfig = [
    {
      key: 'lastName',
      sortable: true,
      title: 'Surname',
      render: row => row.lastName
    },
    {
      key: 'firstName',
      sortable: true,
      title: 'Given Name(s)',
      render: row => (row ? row.firstName : '')
    },
    {
      key: 'email',
      sortable: true,
      title: 'Email',
      render: row => (row ? row.email : '')
    },
    {
      key: 'roles',
      sortable: false,
      title: 'Role',
      render: row =>
        row && row.permissions
          ? row.permissions.map(r => this.rolePipe.transform(r.role)).join(',')
          : ''
    }
  ];

  public inviteConfig = [
    {
      key: 'email',
      sortable: false,
      title: 'Email',
      render: (row: PendingInvitationResponseInterface) => (row && row.to) || ''
    },
    {
      key: 'role',
      sortable: false,
      title: 'Role',
      render: (row: PendingInvitationResponseInterface) => (row && row.role) || ''
    },
    {
      key: 'date',
      sortable: false,
      title: 'Sent',
      render: (row: PendingInvitationResponseInterface) =>
        row && row.token ? moment.unix(row.token.iat).fromNow() : ''
    },
    {
      key: 'exp',
      sortable: false,
      title: 'Expiration',
      render: (row: PendingInvitationResponseInterface) =>
        row && row.token ? moment.unix(row.token.exp).fromNow() : ''
    },
    {
      key: 'actions',
      sortable: false,
      title: 'Actions'
    }
  ];
  public staff: StaffDataSource;
  public invites: InviteDataSource;
  public loading$: Observable<boolean>;
  public page$: Observable<PageEvent>;
  public filter$: Observable<any>;
  public error$: Observable<any>;

  private rolePipe = new RolePipe();

  constructor(public store: Store<any>) {}

  ngOnInit() {
    this.loading$ = this.store.select(selectors.getLoadingAll(selectors.STAFF));
    this.error$ = this.store.select(selectors.getError(selectors.STAFF));
    this.store.dispatch(actions.Staff.RequestPageAction());
    this.staff = new StaffDataSource(this.store.select(selectors.getAll(selectors.STAFF)));
    this.invites = new InviteDataSource(this.store.select(selectors.invite.getPending));
    this.page$ = this.store.select(selectors.getPageination(selectors.STAFF));
    this.filter$ = this.store.select(selectors.getFilter(selectors.STAFF));
    this.store.dispatch(new actions.RequestPendingInvitations());
  }
  paginate(event) {
    this.store.dispatch(actions.Staff.PageChangeAction(event));
  }

  sort(event) {
    if (event.direction) {
      this.store.dispatch(
        actions.Staff.UpdateFilterAction({
          order: `${event.active} ${event.direction.toUpperCase()}`
        })
      );
    }
  }

  resendInvite(id: string) {
    this.store.dispatch(new actions.RequestInvitationResendAction({ id }));
  }
  cancelInvite(id: string) {
    this.store.dispatch(new actions.RequestInvitationCancelAction({ id }));
  }
}

export class StaffDataSource extends DataSource<MemberResponseInterface> {
  constructor(public data: Observable<MemberResponseInterface[]>) {
    super();
  }

  connect() {
    return this.data;
  }

  disconnect() {
    // lint
  }
}

export class InviteDataSource extends DataSource<InvitationResponseInterface> {
  constructor(public data: Observable<InvitationResponseInterface[]>) {
    super();
  }

  connect() {
    return this.data;
  }

  disconnect() {
    // lint
  }
}
